import '../public/static/AelCharteCommun/charte_2016/css/style.css';
import '../public/static/css/vdialog.css';
import '../public/static/AelCharteCommun/charte_2016/css/font-awesome.css';
import 'animate.css/animate.css'; // get animate.css
import FastClick from 'fastclick';

import Vue from 'vue';
import VueProgressBar from 'vue-progressbar'; // get vue-progressbar
import InfiniteScroll from 'vue-infinite-scroll'; // get vue-infinite-scroll
import VCalendar from 'v-calendar';
import BootstrapVue from 'bootstrap-vue';
import VueTheMask from 'vue-the-mask';
import VueCurrencyFilter from 'vue-currency-filter';

import VueLogger from 'vuejs-logger';
import router from './routes';
import store from './store';
import i18n from './i18n';

import './plugins';
import './validation/validations';

import DateFilter from './common/date.filter';
import ErrorFilter from './common/error.filter';

import 'bootstrap';


import App from './App.vue';

import './utils/tooltip';

// Pour faire marcher IE et Safari
require('es6-promise').polyfill();
require('string.prototype.startswith');
require('url-polyfill');

window.Vue = Vue;

Vue.config.debug = process.env.NODE_ENV === 'development';
Vue.config.silent = process.env.NODE_ENV === 'production';
Vue.config.devtools = Vue.config.debug;
Vue.config.productionTip = false;

const coLogOption = {
  isEnabled: true,
  logLevel: 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: false,
  separator: '|',
  showConsoleColors: true,
};
Vue.use(VueLogger, coLogOption);

// eslint-disable-next-line
Vue.config.errorHandler = function (inexError, vm, info) {
  Vue.$log.error('Error custom', inexError);
};

// eslint-disable-next-line
Vue.config.warnHandler = function(inexError, vm, trace) {
  Vue.$log.warn('Warning custom', inexError);
};

Vue.filter('date', DateFilter);
Vue.filter('error', ErrorFilter);

// init fastclick
FastClick.attach(document.body);

const coProgressBarOption = {
  color: '#fff',
  failedColor: '#874b4b',
  thickness: '3px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
  },
  autoRevert: true,
  location: 'top',
  inverse: false,
};

Vue.use(VueProgressBar, coProgressBarOption);
Vue.use(InfiniteScroll);

// Bootstrap
Vue.use(BootstrapVue);
Vue.use(VueTheMask);
Vue.use(VueCurrencyFilter,
  {
    symbol: '',
    thousandsSeparator: '\'',
    fractionCount: 0,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: true,
  });
Vue.use(VCalendar);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
